// extracted by mini-css-extract-plugin
export default {"container":"PrivacyScreen_container__Zq18e","content":"PrivacyScreen_content__kCuDZ","header":"PrivacyScreen_header__lRcho","backButton":"PrivacyScreen_backButton__o5m3V"};